var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYhgl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1680590893670,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 16362,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.247059 36.141176h-126.494118c-72.282353 0-126.494118 54.211765-126.494117 126.494118v698.729412c0 72.282353 54.211765 126.494118 126.494117 126.494118h632.470588c72.282353 0 126.494118-54.211765 126.494118-126.494118v-698.729412c0-72.282353-54.211765-126.494118-126.494118-126.494118h-120.470588v60.235295h120.470588c36.141176 0 66.258824 30.117647 66.258824 66.258823v698.729412c0 36.141176-30.117647 66.258824-66.258824 66.258823h-632.470588c-36.141176 0-66.258824-30.117647-66.258823-66.258823v-698.729412c0-36.141176 30.117647-66.258824 66.258823-66.258823h126.494118v-60.235295z",
    fill: "#ffffff",
    "p-id": 16363
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.505882 96.376471h252.988236v-60.235295h-252.988236zM512 572.235294c84.329412 0 156.611765-72.282353 156.611765-156.611765s-72.282353-156.611765-156.611765-156.611764-156.611765 72.282353-156.611765 156.611764 72.282353 156.611765 156.611765 156.611765z m0-60.235294c-54.211765 0-96.376471-42.164706-96.376471-96.376471s42.164706-96.376471 96.376471-96.37647 96.376471 42.164706 96.376471 96.37647-42.164706 96.376471-96.376471 96.376471z",
    fill: "#ffffff",
    "p-id": 16364
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M734.870588 734.870588c0-120.470588-96.376471-222.870588-222.870588-222.870588s-222.870588 96.376471-222.870588 222.870588h60.235294c0-90.352941 72.282353-162.635294 162.635294-162.635294s162.635294 72.282353 162.635294 162.635294h60.235294z",
    fill: "#ffffff",
    "p-id": 16365
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYhgl);
export default __webpack_public_path__ + "static/media/yhgl.49a1b4f9.svg";
export { ForwardRef as ReactComponent };